// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UL2eiKvPzvQLtA_zVERs{flex-grow:1;margin:0 10px 0 16px;display:flex;position:relative}.JVrM_3fHqL0nvjRqiCwl{justify-content:flex-start;align-items:center;gap:12px;display:flex}.JVrM_3fHqL0nvjRqiCwl .mN8H9rma7zsjOB5KeFYJ{border:1px solid var(--action-outlined-tertiary-border);background:var(--background-primary-inverted-default);border-radius:4px;padding:3px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `UL2eiKvPzvQLtA_zVERs`,
	"sourceCell": `JVrM_3fHqL0nvjRqiCwl`,
	"icon": `mN8H9rma7zsjOB5KeFYJ`
};
export default ___CSS_LOADER_EXPORT___;
